import { render, staticRenderFns } from "./form-land-modal.vue?vue&type=template&id=b01965a8&scoped=true&"
import script from "./form-land-modal.vue?vue&type=script&lang=js&"
export * from "./form-land-modal.vue?vue&type=script&lang=js&"
import style0 from "./form-land-modal.vue?vue&type=style&index=0&id=b01965a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01965a8",
  null
  
)

export default component.exports